import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    let elementsToHighlight = Array.from(document.getElementsByClassName('highlight'));

    if (elementsToHighlight.length > 0) {
      this._scrollElementIntoView(elementsToHighlight[0]);
      this._removeAllHighlightsExceptElements(elementsToHighlight);
    }

    document.addEventListener('promote:highlight', this._onHighlightElement.bind(this));
    document.addEventListener('promote:highlight-added', this._onHighlightAdded.bind(this));
    document.addEventListener('promote:highlight-removed', this._onHighlightRemoved.bind(this));
  }

  disconnect() {
    document.removeEventListener('promote:highlight', this._onHighlightElement.bind(this));
    document.removeEventListener('promote:highlight-added', this._onHighlightAdded.bind(this));
    document.removeEventListener('promote:highlight-removed', this._onHighlightRemoved.bind(this));
  }

  _onHighlightElement(event) {
    const elements = event.detail.elements || [event.detail.element];

    elements.forEach((element) => {
      element.classList.add('highlight');
    });

    this._removeAllHighlightsExceptElements(elements);

    if (event.detail.scroll !== false && elements.length > 0) {
      this._scrollElementIntoView(elements[0]);
    }
  }

  _onHighlightAdded(event) {
    const elements = event.detail.elements || [event.detail.element];

    this._removeAllHighlightsExceptElements(elements);
  }

  _onHighlightRemoved(event) {
    const elements = event.detail.elements || [event.detail.element];

    this._removeAllHighlightsExceptElements(elements);
    this._removeHighlightFromElements(elements);
  }

  _removeAllHighlightsExceptElements(elements) {
    const highlightedElements = document.querySelectorAll('.highlight:not(.js-highlight-static)');

    highlightedElements.forEach((el) => {
      if (elements.includes(el)) return;

      el.classList.remove('highlight');
    });
  }

  _removeHighlightFromElements(elements) {
    elements.forEach((el) => {
      el.classList.remove('highlight');
    });
  }

  _scrollElementIntoView(elem) {
    const scrollContainer = this._findScrollableParent(elem);

    if (scrollContainer) {
      const containerRect = scrollContainer.getBoundingClientRect();
      const elemRect = elem.getBoundingClientRect();

      // Vertical scroll within container
      if (elemRect.bottom > containerRect.bottom) {
        scrollContainer.scrollTop += elemRect.bottom - containerRect.bottom;
      } else if (elemRect.top < containerRect.top) {
        scrollContainer.scrollTop -= containerRect.top - elemRect.top;
      }
    }

    // Horizontal scroll: only if element is outside viewport
    const rect = elem.getBoundingClientRect();
    if (rect.right > window.innerWidth) {
      elem.scrollIntoView({ behavior: "instant", block: 'nearest', inline: "start" });
    }
  }

  _findScrollableParent(elem) {
    let parent = elem.parentElement;

    while (parent && parent !== document.body) {
      const style = getComputedStyle(parent);
      const overflowY = style.overflowY;

      if ((overflowY === 'auto' || overflowY === 'scroll') &&
        parent.scrollHeight > parent.clientHeight) {
        return parent;
      }

      parent = parent.parentElement;
    }

    return null;
  }
}
